import React, {useState, useContext, useEffect, useRef} from 'react'
import UserContext from '../context/UserContext'
import DictionaryContext from '../context/DictionaryContext'
import AsyncSelect from 'react-select/async'
import Select from 'react-select'
import {Row, Col, Button, ButtonGroup, ToggleButton} from 'react-bootstrap'
import FormFields from './FormFields'
import styles from './InventoryForm.module.css'
import './SearchBar.css'

function SearchBar(props) {
    const userCtx = useContext(UserContext)
    const dictCtx = useContext(DictionaryContext)
    const baseURL = process.env.REACT_APP_MODE === "PROD" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_TEST

    const [inputValue, setInputValue] = useState('')
    // const [searchType, setSearchType] = useState(props.searchType) 
    const selectInputRef = useRef({})

    // fields for location search
    // const location_fields = FormFields().filter(d => !!d.location_search)
    // const lab_fields = FormFields().filter(d => !!d.lab_search)

    const [searchFields, setSearchFields] = useState([])
    const certificationTypes = [{
            label:'Not Certified',
            value: 'Not Certified',
        },
        {
            label:'With Certification',
            value: 'With Certification',
        } ,
        // {
        //     label:'With Final Certification',
        //     value: 'With Final Certification',
        // }
      ]


    const searchBarLabels = [
        {searchType: 'by_all', label: ''},
        {searchType: 'by_name', label: 'Name or User Id'},
        {searchType: 'by_lab', label: 'Lab'},
        {searchType: 'by_dev_type', label: 'Device Type'},
        {searchType: 'by_cert_status', label: 'Certification Status'},
        {searchType: 'by_req_onsite_encr_ver', label: 'On-site Ecryption Validation Requested'},
        {searchType: 'by_mass_certification', label: 'Device Type'},
    ]

    // used for values from react-select
    const [dropdowns, setDropdowns] = useState([])
    const [item, setItem] = useState(null)
    const [users, setUsers] = useState([])
    
    const searchTypeChanged = (event) => {
        // console.log("Search Type Changed to", event.target.value)
        // setSearchType(event.target.value)
        props.setSearchCriteria({})
        props.onSearchTypeChange(event.target.value)
        // if by name, populate names
        // if (event.target.value === 'by_name') {
        //     // prepopulate array of users
        //     loadOptions('')
        // }
    }

    const handleInputChange = (value, details) => {
        // console.log("handleInputChange", value)
        setInputValue(value);
    }

    // item selected (in value) - need to populate data 
    const handleChange = (value, details) => {
        // console.log("handleChange value", value)
        // console.log("handleChange details", details)
        let searchCriteria = {};
        if (details?.action === 'clear') {
            props.setSearchCriteria(searchCriteria)
        } else {
            switch(props.searchType ) {
                case 'by_all':
                    props.onSelect(value);
                    break;
                case 'by_name':
                    // get the list of all items by employee
                    searchCriteria = {...searchCriteria,
                        searchTerm: 'user_id', 
                        value: value.value,
                        label: value.label,
                    }
                    props.setSearchCriteria(searchCriteria)
                    break;
                case 'by_lab':
                    // get the list of all items by employee
                    searchCriteria = {...searchCriteria,
                        searchTerm: 'lab', 
                        value: value.value,
                        label: value.label,
                    }
                    props.setSearchCriteria(searchCriteria)
                    break;
                case 'by_dev_type':
                    // get the list of all items by employee
                    searchCriteria = {...searchCriteria,
                        searchTerm: 'dev_type', 
                        value: value.value,
                        label: value.label,
                    }
                    props.setSearchCriteria(searchCriteria)
                    break;
                case 'by_cert_status':
                    searchCriteria = {...searchCriteria,
                        searchTerm: 'by_cert_status', 
                        value: value.value,
                        label: value.label,
                    }
                    props.setSearchCriteria(searchCriteria)

                    break;

                case 'by_mass_certification':
                    // get the list of all items by employee
                    searchCriteria = {...searchCriteria,
                        searchTerm: 'dev_type', 
                        value: value.value,
                        label: value.label,
                    }
                    props.setSearchCriteria(searchCriteria)
                    break;

                // case 'by_req_onsite_encr_ver':
                //     searchCriteria = {...searchCriteria,
                //         searchTerm: 'by_req_onsite_encr_ver', 
                //         value: value.value,
                //         label: value.label,
                //     }
                //     console.log("Search Bar - search criteria", searchCriteria)
                //     props.setSearchCriteria(searchCriteria)

                //     break;
            }
        }

    }


   

    // load options 
    const loadOptions = async (inputValue) => {
        let options = []
        // console.log("load options by search type", props.searchType)
        if (!!inputValue && inputValue.length > 0) {
            let searchURL = ''
            switch(props.searchType) {
                
                case 'by_location':
                    searchURL = `${baseURL}inventories/search_inventories/by_location/${inputValue}`
                    break
                case 'by_all':
                    searchURL = `${baseURL}inventories/search_inventories/${inputValue}`
                    break
            }
            
            
            await fetch(searchURL, {
                method: 'GET',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`
                }
            })
            .then((response) => response.json())
            .then(data => {
                if (props.searchType === 'by_all') {
                    // console.log("search results", data.data)
                    if (!!data.data && data.data.length > 0) {
                        options = data.data.map(d => {
                            return {
                                label: `${d.last_name}, ${d.first_name} - Sticker: ${!!d.hospital_sticker_id ? d.hospital_sticker_id : "NONE"} - SR: ${!!d.serial_number ? d.serial_number : "NONE"}`,
                                id: d.id
                            }
                        })
                    }
                }
            })
            .catch(e => {
                console.log("error getting all items", e)
            })

        } 
        return options
        
    }


    const getAllUsers = async () => {
        let options = []
        const searchURL = `${baseURL}inventories/inventories/list_of_employees`;
        await fetch(searchURL, {
            method: 'GET',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`
            }
        })
        .then((response) => response.json())
        .then(data => {
            if (!!data && data.length > 0) {
                options = data.map(d => {
                    return {
                        label: `${d.employee_acct} - ${d.last_name}, ${d.first_name}`,
                        value: d.employee_acct,
                    }
                })
                setUsers(options) 
                // console.log("options", options)
            }
        })
        .catch(e => {
            console.log("error getting all items", e)
        })
       
    }




    const getOptionValue = (e) => {
        // console.log("getOptionValue", e)
        return e['id']

        
    }

    const getOptionLabel = (e) => {
        // console.log("getOptionLabel", e)
        return(e['label'])
    }



    // populate options for select - from a dictionary
    const getSelectOptions = (field) => {
        const field_dict = dictCtx[`dict_${field.dictionary.toLowerCase()}`]

        // console.log("getSelectOptions - field, field_dict", field, field_dict)

        if (!!field.depends_on && field.type==='dictionary') {
            // options of this field depend on the value of another field - filter options accordingly
            // 1. find value of "parent" field in dropdowns
            const parent = dropdowns.find(d => d.name === field.depends_on)
            if (!!parent) {
                return field_dict.filter(fd => fd.dictionary_type === parent.option.value).map(de => {
                    return {
                        label: de.dictionary_detail,
                        value: !!field.value_field ? de[field.value_field]: de.dictionary_value, 
                    }
                })
            }
        } else if (!!field.depends_on && field.type==='checkbox') {
            // nothig here - just a placeholder for possible extra processing of is_lab field

        } else {
            // doesn't depend on anything - no need to filter dictionary values
            return field_dict.map(de => {
                return {
                    label: de.dictionary_detail,
                    value: !!field.value_field ? de[field.value_field]: de.dictionary_value, 
                }
            })
        }

    }



    // drpdown selected value
    const onSelect = (name, e) => {

        // console.log("selected", name, e, e.value)
        setItem({...item, [name]: !!e? e.value : ''})
        let dVals = [...dropdowns]
        let indx = dVals.findIndex(d => d.name === name)
        // let field;
        // let fields = []

        // if (props.searchType === 'by_location') {
        //     fields = location_fields
        //     // field = location_fields.find(f => f.name === name) 
        // } 
        // if (props.searchType === 'by_lab') {
        //     fields = lab_fields
        //     // field = lab_fields.find(f => f.name === name) 
        // } 
        // let field = fields.find(f => f.name === name) 

        let field = searchFields.find(f => f.name === name) 

        // console.log("field", field)

        dVals[indx] = {...dVals[indx], option: {label: !!e ? e.label : '', value: !!e ? e.value : field.null_value}}


        // special processing for dropdowns with dependants - field has property dependant; clearing that field should clear dependant value as well
        // if a value selected then depandant dropdown should be populated with corresponding values
        
        if (!!field.dependant) {
            // there is a dependant - clear the values
            // const field2 = location_fields.find(f => f.name === field.dependant)
            const field2 = searchFields.find(f => f.name === field.dependant)
            indx = dVals.findIndex(d => d.name === field.dependant)

            // console.log("onSelect: field2, indx, dVals[indx]", field2, indx, dVals[indx])
            if (field2.type === 'dictionary') {
                dVals[indx] = {...dVals[indx], option: {label: '', value: field2.null_value}}
            } else if (field2.type === 'checkbox') {
                if (!!e && !!e.value) {
                    dVals[indx] = {...dVals[indx], option: {label: '', value: field2.checked}}
                }
            }
            
        }
        
        // console.log("new values of dropdowns", dVals)
        setDropdowns([...dVals])
    } 

    
    const selectStyles = {
        container: base => ({
            ...base,
            class: 'input input-sm input-bordered rounded-lg mr-4',
            // width: "20rem",
            height: "2rem",
            // border: 
        }),
        control: base => ({
            ...base,
            height: 32,
            minHeight: 32,
            // fontSize: 16,
            borderRadius: "0.5rem",
            // width: "100%",
            // textAlign: "left",
            // cursor: "pointer",
            // border:0,
            class: 'input-bordered rounded-lg mr-4',
        }),
        indicatorSeparator: base => ({
            ...base,
            margin: "0px 0 6px 0",

        }),
        // to fix problem when the dropdown hides UNDER other elements on the page
        // set zIndex for menuPOrtal and menu:
        menuPortal: base => ({ 
            ...base, 
            zIndex: 9999,
        }),
        menu: base => ({ 
            ...base, 
            zIndex: 9999,
        }) 
    }



    useEffect(() => {
        // there is no search field for all_items and by_location, so nothing to clear
        if (props.clear && props.searchType === 'by_lab') {
            selectInputRef.current[props.searchType].clearValue();
        }
    }, [props.clear])



    

    useEffect(() => {
        // populate searchFields array
        const sFields = FormFields().filter(d => Array.isArray(d?.search) ? d?.search.includes(props.searchType) : d?.search === props.searchType)
        setSearchFields(sFields)
        // console.log("sFields", sFields)

        // populate dropdowns
        let initVals = []
        if (sFields.length > 0) {
            sFields.forEach(f => {
                const val = f.null_value
                const dict_entry = dictCtx[`dict_${f.dictionary.toLowerCase()}`].find(de => de[f.value_field] === val)
                // console.log("dict_entry", dict_entry)
                const label = !!dict_entry ? dict_entry.dictionary_detail : ''
                // console.log("setting up initial value for", f.name, val)
                initVals.push({name: f.name, option: {label: label, value: val}})
            })
        }
        // console.log("Initialized dropdowns",initVals)
        setDropdowns([...initVals])
        // setSearchType(props.searchType)
        // if by name, populate names
        if (props.searchType === 'by_name') {
            // prepopulate array of users
            getAllUsers()
        }

    }, [props.searchType, props.searchCriteria])


    return (
        <div className='my-2 flex flex-wrap items-center'>
            <label className="ms-5 me-3">Search By</label>
            <ButtonGroup className="btn-group mb-2 ms-5 me-5 w-3/5" role="group" aria-label="Basic radio toggle button group Search type">
                <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id="radio_by_all" 
                    autoComplete="off" 
                    value='by_all' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'by_all'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_all">Serial # or Control tag</label>

                <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id="radio_by_name" 
                    autoComplete="off" 
                    value='by_name' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'by_name'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_name">User id or Name</label>

                {/* <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id="radio_by_location" 
                    autoComplete="off" 
                    value='by_location' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'by_location'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_location">By location</label> */}

                <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id="radio_by_lab" 
                    autoComplete="off" 
                    value='by_lab' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'by_lab'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_lab">Lab</label>


                <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id="radio_by_dev_type" 
                    autoComplete="off" 
                    value='by_dev_type' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'by_dev_type'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_dev_type">Device type</label>


                <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id='radio_by_cert_type' 
                    autoComplete="off" 
                    value='by_cert_status' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'by_cert_status'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_cert_type">All Inventories/Certification</label>


                {/* <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id="radio_all" 
                    autoComplete="off" 
                    value='all_items' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'all_items'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_all">All Inventories</label> */}


                <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id='radio_by_req_onsite_encr_ver' 
                    autoComplete="off" 
                    value='by_req_onsite_encr_ver' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'by_req_onsite_encr_ver'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_req_onsite_encr_ver">On-site Encryption Verification Requested</label>


                <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id='radio_by_non_blank_comments' 
                    autoComplete="off" 
                    value='by_non_blank_comments' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'by_non_blank_comments'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_non_blank_comments">With Comments</label>

                <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id='radio_by_no_inventories' 
                    autoComplete="off" 
                    value='by_no_inventories' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'by_no_inventories'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_no_inventories">No Devices</label>

                {/* {dictCtx.dict_attestion_status === 'ON' && 
                    <>
                    <input 
                        type="radio" 
                        className="btn-check" 
                        name="btnradio" 
                        id='radio_by_not_attested' 
                        autoComplete="off" 
                        value='by_not_attested' 
                        onChange={searchTypeChanged}
                        checked={props.searchType === 'by_not_attested'}
                    />
                    <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_not_attested">Not Attested</label>
                    </>
                } */}
                <input 
                    type="radio" 
                    className="btn-check" 
                    name="btnradio" 
                    id='radio_by_mass_certification' 
                    autoComplete="off" 
                    value='by_mass_certification' 
                    onChange={searchTypeChanged}
                    checked={props.searchType === 'by_mass_certification'}
                    />
                <label className="btn btn-sm btn-outline-primary" htmlFor="radio_by_mass_certification">Mass Certification</label>



            </ButtonGroup>

            <Row>
                {props.searchType === 'by_all' && 
                <Col>
                    <AsyncSelect 
                        ref={(el) => selectInputRef.current['by_all'] = el || ''}
                        // className='input input-sm input-bordered rounded-lg mr-4 w-1/4 my-4 mx-5'
                        className='mr-4 mx-5 w-3/5'
                        getOptionLabel={getOptionLabel}
                        getOptionValue={getOptionValue}
                        loadOptions={loadOptions}
                        isClearable={true}
                        isSearchable={true}
                        styles={selectStyles}
                        placeholder='type name, serial number or tag'
                        onChange={handleChange}
                        onInputChange={handleInputChange}
                        noOptionsMessage={(e) => !!inputValue ? 'No items matching your search criteria found' : 'type name, serial number or tag'}
                        isLoading={false}
                    />
                </Col>
                }


                {(props.searchType === 'by_name' || props.searchType === 'by_lab' || props.searchType === 'by_dev_type' || props.searchType === 'by_cert_status'
                    || props.searchType === 'by_mass_certification' ) && 
                    <div className={`'container-fluid' ${styles['inline-block']} `}>
                        <label className='ms-5 me-3 '>{searchBarLabels.find(l => l.searchType === props.searchType)?.label}</label>

                        <div className={`${styles['inline-block']} ms-5 col-lg-3 col-md-5 col-sm-6 col-7 `}>

                            {props.searchType === 'by_name' &&
                            
                                <Select 
                                    ref={(el) => selectInputRef.current[props.searchType] = el || ''}
                                    options={users}
                                    isClearable={true}
                                    isSearchable={true}
                                    styles={selectStyles}
                                    placeholder='type user id or name'
                                    onChange={handleChange}
                                    onInputChange={handleInputChange}
                                    noOptionsMessage={(e) => !!inputValue ? 'No items matching your search criteria found' : 'type user id or name'}
                                    isLoading={false}
                                    defaultValue={{label: props.searchCriteria?.label, value: props.searchCriteria?.value}}
                                />

                            }

                            {(props.searchType === 'by_lab' || props.searchType === 'by_dev_type') && 
                                searchFields.map(f => {
                                    return (
                                        f.show && ((!!f.admin_only && props.mode === "admin") || !!!f.admin_only) ?

                                            <Select
                                                key={f.name}
                                                className='mr-4 w-3/5'
                                                styles={selectStyles}
                                                ref={(el) => selectInputRef.current[props.searchType] = el || ''}
                                                isClearable={true}
                                                menuPortalTarget={document.body}
                                                isSearchable={true}
                                                // name={f.name}
                                                options={getSelectOptions(f)}
                                                // onChange={(e) => onSelect(f.name, e)}
                                                onChange={handleChange}
                                                // value={dropdowns.find(d=>d.name===f.name).option || ''}
                                                defaultValue={{label: props.searchCriteria?.label, value: props.searchCriteria?.value}}
                                            />
                                        :
                                        null
                                    )
                                })
                            }  


                            {(props.searchType === 'by_cert_status') && 



                                <Select 
                                    // ref={(el) => selectInputRef.current['by_cert_type'] = el || ''}
                                    className='mr-4 w-3/5'
                                    options={certificationTypes}
                                    isClearable={true}
                                    isSearchable={true}
                                    styles={selectStyles}
                                    placeholder='All Certification Statuses'
                                    // defaultInputValue={props.searchCriteria.value}
                                    defaultValue={!!props.searchCriteria.value ? {label: props.searchCriteria?.label, value: props.searchCriteria?.value} : null}
                                    menuPortalTarget={document.body}
                                    onChange={handleChange}
                                    onInputChange={handleInputChange}
                                    noOptionsMessage={(e) => !!inputValue ? 'No items matching your search criteria found' : 'select certification status'}
                                    isLoading={false}
                                />

                            }


                            {props.searchType === 'by_mass_certification' && 
                                searchFields.map(f => {
                                    return (
                                        f.show && ((!!f.admin_only && props.mode === "admin") || !!!f.admin_only) ?

                                            <Select
                                                key={f.name}
                                                className='mr-4 w-3/5'
                                                styles={selectStyles}
                                                ref={(el) => selectInputRef.current[props.searchType] = el || ''}
                                                isClearable={true}
                                                menuPortalTarget={document.body}
                                                isSearchable={true}
                                                // name={f.name}
                                                options={getSelectOptions(f)}
                                                // onChange={(e) => onSelect(f.name, e)}
                                                onChange={handleChange}
                                                // value={dropdowns.find(d=>d.name===f.name).option || ''}
                                                defaultValue={{label: props.searchCriteria?.label, value: props.searchCriteria?.value}}
                                            />
                                        :
                                        null
                                    )
                                })
                            }  

                        </div>
                    </div>
                }
            </Row>
            
            

            

            {/* {props.searchType === 'by_location' && 
                <Row>
                    {location_fields.map(f => {
                        return (
                            f.show && ((!!f.admin_only && props.mode === "admin") || !!!f.admin_only) ?
                            <Col key={f.name} md={4} sm={6} xs={12} className={`${styles.handle_overflow} `}>
                                <div key={f.name} >
                                    <label htmlFor={f.name} className={styles.field_header}>{f.display_name}</label>

                                    <div >
                                        {f.type === 'dictionary' && dropdowns.length > 0 &&
                                            // <div className=' flex flex-wrap items-center mt-5'>
                                            <>
                                                <Select
                                                    // theme={customThemeFn}
                                                    // styles={select_styles(f.name)}
                                                    // styles={select_styles}
                                                    isClearable={true}
                                                    menuPortalTarget={document.body}
                                                    isSearchable={true}
                                                    name={f.name}
                                                    options={getSelectOptions(f)}
                                                    // ref={(el) => inputRefs.current[f.name] = el}
                                                    onChange={(e) => onSelect(f.name, e)}
                                                    value={dropdowns.find(d=>d.name===f.name).option || ''}
                                                />
                                            
                                            </>
                                            //</div>
                                        }

                                    
                                    </div>
                                </div>
                            </Col>
                            :
                            null
                            
                        )
                    })}
                </Row>
                
            } */}
            


            

            
        </div>
    )
}

export default SearchBar
